import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
const products = [{
  category: 'Ebook',
  title: 'Los 7 Principios',
  description: 'El manual del emprendedor consciente',
  price: 27,
  featured: false,
  gradient: 'from-amber-100 to-orange-100'
}, {
  category: 'Audio Pack',
  title: 'Meditaciones de Abundancia',
  description: '10 audios para reprogramar tu mente',
  price: 47,
  featured: false,
  gradient: 'from-blue-100 to-indigo-100'
}, {
  category: 'Programa',
  title: 'Negocio en 30 Días',
  description: 'De idea a primeras ventas en un mes',
  price: 197,
  featured: false,
  gradient: 'from-emerald-100 to-teal-100'
}, {
  category: 'Hipnosis',
  title: 'Reprogramación de Identidad',
  description: 'Transforma quién eres desde dentro',
  price: 37,
  featured: false,
  gradient: 'from-purple-100 to-pink-100'
}, {
  category: 'Bundle',
  title: 'Pack Emprendedor Consciente',
  description: 'Todo lo que necesitas para comenzar',
  price: 97,
  originalPrice: 197,
  featured: true,
  gradient: 'from-gold-light to-amber-200'
}, {
  category: 'Masterclass',
  title: 'Marca Personal en 7 Días',
  description: 'Posiciónate como experto rápidamente',
  price: 67,
  featured: false,
  gradient: 'from-rose-100 to-red-100'
}, {
  category: 'Audio',
  title: 'Activación de Energía Femenina',
  description: 'Reconecta con tu poder interior',
  price: 27,
  featured: false,
  gradient: 'from-fuchsia-100 to-purple-100'
}, {
  category: 'Programa',
  title: 'Ecommerce desde Cero',
  description: 'Tu tienda online paso a paso',
  price: 297,
  featured: false,
  gradient: 'from-cyan-100 to-blue-100'
}];
export function DigitalStore() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="tienda" ref={ref} className="py-24 md:py-32 bg-white" data-id="element-79">
      <div className="max-w-7xl mx-auto px-6" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-16" data-id="element-81">
          <p className="font-sans text-sm uppercase tracking-widest text-gold mb-4" data-id="element-82">
            Recursos digitales
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal mb-6" data-id="element-83">
            Tienda Digital
          </h2>
          <p className="font-sans text-lg text-charcoal-mid font-light max-w-xl mx-auto" data-id="element-84">
            Herramientas para tu transformación. Acceso inmediato.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-85">
          {products.map((product, index) => <motion.div key={product.title} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.08,
          ease: 'easeOut'
        }} className={`group bg-cream rounded-2xl overflow-hidden ${product.featured ? 'ring-2 ring-gold' : ''}`} data-id="element-86">
              <div className={`aspect-square bg-gradient-to-br ${product.gradient} flex items-center justify-center relative`} data-id="element-87">
                {product.featured && <span className="absolute top-3 right-3 px-2 py-1 bg-gold text-white text-xs font-medium rounded-full" data-id="element-88">
                    Destacado
                  </span>}
                <span className="font-serif text-4xl text-charcoal/20" data-id="element-89">
                  {product.title.charAt(0)}
                </span>
              </div>
              <div className="p-5" data-id="element-90">
                <span className="inline-block px-2 py-0.5 bg-beige text-charcoal-mid text-xs rounded-full mb-2" data-id="element-91">
                  {product.category}
                </span>
                <h3 className="font-serif text-lg text-charcoal mb-1" data-id="element-92">
                  {product.title}
                </h3>
                <p className="font-sans text-sm text-charcoal-mid mb-4" data-id="element-93">
                  {product.description}
                </p>
                <div className="flex items-center justify-between" data-id="element-94">
                  <div className="flex items-baseline gap-2" data-id="element-95">
                    <span className="font-serif text-2xl text-charcoal" data-id="element-96">
                      ${product.price}
                    </span>
                    {product.originalPrice && <span className="font-sans text-sm text-charcoal-light line-through" data-id="element-97">
                        ${product.originalPrice}
                      </span>}
                  </div>
                  <button className="px-4 py-2 bg-charcoal text-cream text-sm font-sans font-medium rounded-full hover:bg-charcoal-mid transition-colors duration-300" data-id="element-98">
                    Comprar
                  </button>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}